var navLinks = document.querySelectorAll(".header__menu-item");
var nav = document.querySelector(".header-wrapper");
var navOpenCheck = document.querySelectorAll(".header__menu-item");

var logo = document.querySelector(".home .header--mobile-center .header__heading-logo");

if (logo){
  var logoSrc = logo.src;

  if (logo) {
    logo.src = "https://cdn.shopify.com/s/files/1/0675/2842/5775/files/whitelogo.png";
    logo.srcset = "https://cdn.shopify.com/s/files/1/0675/2842/5775/files/whitelogo.png";
  }
  
  document.onclick = function(){
    if (window.innerWidth > 1250){
      fullNavBG(event);
    }
  }
  
  var icon = document.querySelector(".home .header--mobile-center .menu-drawer-container .header__icon");
  
  if (icon){
    icon.addEventListener("click", navBG);
  }
  
  function navBG(){
    var item = event.target;
  
    if (logo){
      if (window.innerWidth < 1250 && item.classList.contains("icon-hamburger") || window.innerWidth < 1250 && item.parentElement.classList.contains("icon-hamburger")){
        /*set logo to base*/
        console.log(logoSrc);
        logo.src = logoSrc;
        logo.srcset = logoSrc;
  
        /*change icon colors*/
        var icons = document.querySelectorAll(".home .header__icon svg path");
  
        for (let i = 0; i < icons.length; i++){
          icons[i].style.fill = "rgb(166, 40, 52)";
        }
  
        /*change background color*/
        var styleElem = document.head.appendChild(document.createElement("style"));
  
        styleElem.innerHTML = ".home.header-wrapper::after {background-color: white; opacity: 1;}";
  
        styleElem.classList.add("remove");
        
      } else{
        /*set logo to white*/
        logo.src = "https://cdn.shopify.com/s/files/1/0675/2842/5775/files/whitelogo.png";
        logo.srcset = "https://cdn.shopify.com/s/files/1/0675/2842/5775/files/whitelogo.png";
  
        /*change icon colors*/
        var icons = document.querySelectorAll(".home .header__icon svg path");
  
        for (let i = 0; i < icons.length; i++){
          icons[i].style.fill = "white";
        }
  
        /*change background color*/
        document.head.querySelector(".remove").remove();
      }
    }
  }
  
  function fullNavBG(event, test){
    var item;
    if (event.target){
      item = event.target;
    }
    var openElement;
    var links = document.querySelectorAll(".home .header--mobile-center .header__menu-item");
    var icons = document.querySelectorAll(".home .header--mobile-center .header__icon path");
  
    if (test == "true" || nav.contains(item)){
      for (let i = 0; i < navOpenCheck.length; i++) {
        if (navOpenCheck[i].ariaExpanded == "true"){
          openElement = navOpenCheck[i];
        }
      }
      if (openElement == undefined){
        nav.style.backgroundColor = "rgba(var(--color-shadow),.25)";
        logo.src = "https://cdn.shopify.com/s/files/1/0675/2842/5775/files/whitelogo.png";
        logo.srcset = "https://cdn.shopify.com/s/files/1/0675/2842/5775/files/whitelogo.png";
  
        for (let i = 0; i < links.length; i++) {
          if (links[i].id != "HeaderMenu-clearance"){
            links[i].style.color = "white";
          }
        }
  
        for (let i = 0; i < icons.length; i++) {
          icons[i].style.fill = "white";
        }
      }
      if (openElement.contains(item)){
        nav.style.backgroundColor = "white";
        logo.src = logoSrc;
        logo.srcset = logoSrc;
  
        for (let i = 0; i < links.length; i++) {
          links[i].style.color = null;
        }
  
        for (let i = 0; i < icons.length; i++) {
          icons[i].style.fill = null;
        }
      }
    } else {
      nav.style.backgroundColor = "rgba(var(--color-shadow),.25)";
  
      for (let i = 0; i < links.length; i++) {
        if (links[i].id != "HeaderMenu-clearance"){
          links[i].style.color = "white";
        }
      }
  
      for (let i = 0; i < icons.length; i++) {
        icons[i].style.fill = "white";
      }
    }
  }
  
  window.addEventListener('resize', function(){
    if (window.innerWidth > 1250){
      fullNavBG(event, "true");
    }
  });
}
